import { Box, Text } from '@atom-web/micros'
import dynamic from 'next/dynamic'
import React from 'react'

import isIxigoPartnersSite from '../utils/isIxigoPartnersSite'
import ContentWrapper from './ContentWrapper'

const FooterWrapper = dynamic(() => import('./atom/wrappers/FooterWrapper'))
const NavbarWrapper = dynamic(() => import('./atom/wrappers/NavbarWrapper'))

function AppLayout({
	footerData,
	hideNavbar = false,
	hideFooter = false,
	navbarProps = {},
	footerProps = {},
	children,
	isPaid = false,
}) {
	const isIxigoPartnersSiteValue = isIxigoPartnersSite()

	return (
		<>
			{hideNavbar ? null : <NavbarWrapper isPaid={isPaid} {...navbarProps} />}
			{children}
			{hideFooter || isPaid ? null : isIxigoPartnersSiteValue ? (
				<Box
					css={{
						padding: '8px 0 16px 0',
						background: '$black',
					}}
				>
					<ContentWrapper>
						<Text
							size="3"
							css={{
								color: '$white',
								lineHeight: '24px',
								marginTop: '6px',
								textAlign: 'center',
							}}
						>
							Travel Troops Global Private Ltd. © {new Date().getUTCFullYear()}{' '}
							all rights reserved.
						</Text>
					</ContentWrapper>
				</Box>
			) : (
				<FooterWrapper footerData={footerData} {...footerProps} />
			)}
		</>
	)
}

export default AppLayout
